import React from "react";
import { Accordion as AccordionBS } from "react-bootstrap";
import style from "./style.module.scss";

const Accordion = props => {
  const { active, onlyHeader, isHide } = props;
  return (
    <AccordionBS
      defaultActiveKey={active}
      className={style.accordion}
      data-only-header={!!onlyHeader}
      style={
        isHide
          ? {
              display: "none",
            }
          : {}
      }
      {...props}
    >
      {props.children}
    </AccordionBS>
  );
};

const Item = props => {
  const { children, eventKey, className, ...rest } = props;
  const _eventKey = !!eventKey ? { eventKey } : {};
  return (
    <AccordionBS.Item {..._eventKey} className={`${style.accordion_item} ${className || ""}`} {...rest}>
      {children}
    </AccordionBS.Item>
  );
};

const Header = props => {
  return (
    <>
      <AccordionBS.Header className={style.Accordion_BS_header}>{props.children}</AccordionBS.Header>
    </>
  );
};
const Body = props => {
  return <AccordionBS.Body className={style.accordion_body}>{props.children}</AccordionBS.Body>;
};

const Extras = props => {
  return (
    <span
      className={`${style.accordion_extras} ${props.className}`}
      onClick={ev => {
        ev.stopPropagation();
      }}
    >
      {props.children}
    </span>
  );
};

Accordion.Item = Item;
Accordion.Header = Header;
Accordion.Body = Body;
Accordion.Extras = Extras;
export default Accordion;
